<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  loading: { type: Boolean, default: false },
  updatedAt: { type: [Date, String, Number], default: null },
});

const emit = defineEmits(['refresh']);
const { t } = useI18n();
const clock = ref(Date.now());
let timer;

const elapsedMinutes = computed(() => {
  if (!props.updatedAt) return null;
  const updatedAt = new Date(props.updatedAt);
  return Math.max(0, Math.floor((clock.value - updatedAt.getTime()) / 60000));
});

onMounted(() => {
  timer = window.setInterval(() => {
    clock.value = Date.now();
  }, 60000);
});
onBeforeUnmount(() => window.clearInterval(timer));
</script>

<template>
  <div class="flex shrink-0 items-center gap-[13px]">
    <button
      class="inline-flex h-9 items-center gap-2 rounded-[10px] px-2 text-sm font-bold text-[#464F53] transition hover:bg-[#EDF8F7] disabled:cursor-wait disabled:opacity-60"
      type="button"
      :disabled="loading"
      :aria-busy="loading ? 'true' : 'false'"
      @click="emit('refresh')"
    >
      <span
        class="size-4 text-[#01988C]"
        :class="
          loading
            ? 'i-lucide-loader-circle animate-spin'
            : 'i-lucide-refresh-cw'
        "
        aria-hidden="true"
      />
      {{ t('SALES.REFRESH_STATUS.ACTION') }}
    </button>
    <span v-if="elapsedMinutes !== null" class="text-sm text-[#464F53]">
      {{
        t('SALES.REFRESH_STATUS.UPDATED_AGO', {
          minutes: elapsedMinutes,
        })
      }}
    </span>
  </div>
</template>
